import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html, body, #__next {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    scroll-behavior: smooth;
  }

  * {
    text-decoration: none;
    scroll-behavior: smooth !important;
  }

  body,h1,h2,h3,h4,h5,h6,p {
    color: ${props => props.theme.colors.display[900]};
    font-family: var(--font-sans);
  }

  div {
    font-family: var(--font-sans);
  }

  .leading-54 {
    line-height: 54px;

    @media (max-width: 443px) {
      line-height: 44px;
    }
  }

  h1 {
    font-size: 48px;
    line-height: 56px;
  }

  h2 {
    font-size: 40px;
    line-height: 48px;
  }

  h3 {
    font-size: 32px;
    line-height: 40px;
  }

  h4 {
    font-size: 28px;
    line-height: 36px;
  }

  h5 {
    font-size: 24px;
    line-height: 32px;
  }

  h6 {
    font-size: 20px;
    line-height: 28px;
  }

  p {
    line-height: 24px;
    font-size: 16px;
    font-family: var(--font-sans);
  }
    input, textarea {
    font-family: var(--font-sans);
  }

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    h1 {
      font-size: 36px;
      line-height: 44px;
    }

    h2 {
      font-size: 32px;
      line-height: 38px;
    }

    h3 {
      font-size: 28px;
      line-height: 36px;
    }

    h4 {
      font-size: 24px;
      line-height: 32px;

    }

    h5 {
      font-size: 20px;
      line-height: 28px;

    }

    h6 {
      font-size: 18px;
      line-height: 26px;
    }

    p {
      font-size: 2;
    }
  }

  button {
    background: none;
    outline: none;
    padding: 0;
  }

  button, a {
    cursor: pointer;
    border: none;
    font-size: 16px;
    font-family: var(--font-sans);
  }

  a {
    text-decoration: none;
  }

  // Twilio: Widget
  .Twilio-MainContainer {
    z-index: 9999 !important;
  }
  
  .Twilio-MessageList > div:nth-child(3) {
    display: none !important;
  }

 // BANNER SECURITI: Cookie Consent
  //main div
  .cc-window.cc-banner {
    padding: 16px;
    border-radius: 8px 8px 0px 0px;
    box-shadow: 0px 8px 50px 0px rgba(66, 74, 83, 0.30);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
  }

  //text div
  .cc-window .cc-message-container {
    color: var(--Display-900, #20252A);
    text-align: center;
    font-size: 12px;
    padding: 0;
    margin: 0;
    font-family: var(--font-sans);
  }
  .cc-window .cc-message {
    padding: 0;
    margin: 0;
  }

  //text
  .cc-window .cc-message p {
    font-size: 14px;
    line-height: 20px;
  }

  //cookie policy div
  .cc-window .cc-message a {
    font-size: 14px;
    line-height: 20px;
  }

  //preferences text
  .cc-window .cmp-pref-link span:last-child {
    display: none;
  }

  //buttons div
  .cc-window .cc-compliance {
    padding: 0;
    align-self: center;
    justify-content: center;
    gap: 12px;
  }

  //buttons
  .cc-banner.cc-theme-classic .cc-compliance a {
    margin: 0;
    padding: 0px 16px;
    align-items: center;
  }

  //rounded buttons
  .cc-btn,.cc-allow,.cc-dismiss {
    border-radius: 32px;
    text-align: center;
    font-family: var(--font-sans);
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
  }

  //allow cookies button
  .cc-banner.cc-theme-classic .cc-compliance a:first-child {
    background: var(--Stone-500, #00A868) !important;
    color: #fff !important;
    border: none;
    padding: 12px 8px;
  }
  
  //partially accept cookies button
  .cc-banner.cc-theme-classic .cc-compliance a:nth-child(even) {
    border: 1px solid var(--Display-400, #BCC8D6) !important;
    background: var(--Display-0, #FFF) !important;
  }

  //cookie settings button
  .cc-banner.cc-theme-classic .cc-compliance a:last-child {
    width: 24px;
    height: 24px;
    align-self: center;
    justify-content: center;
    padding: 0;
    margin: 0;
  }

  @media (min-width: 769px) {
    .cc-window.cc-banner {
      flex-direction: row;
      padding: 24px;
      gap: 24px;
      border-radius: 16px 16px 0px 0px;
    }

    .cc-window .cc-message p {
      font-size: 16px;
      line-height: 24px;
    }

    .cc-window .cc-message a {
      font-size: 16px;
      line-height: 24px;
    }

    .cc-window .cc-compliance {
      gap: 16px;
    }

    .cc-banner.cc-theme-classic .cc-compliance a {
      margin: 0;
      padding: 12px 16px;
      justify-content: center;
    }

    .cc-btn,.cc-allow,.cc-dismiss {
      font-size: 12px;
      font-weight: 700;
    }
  }


  //Reset Tailwind
  *,
  ::before,
  ::after {
    border-width: 0;
    border-style: solid;
    border-color: theme('borderColor.default', currentColor);
  }

  ol,
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  * {
	margin: 0;
	padding: 0;
	box-sizing: border-box
}

// FONTS configuration

body,
input {
  font-family: UniNeue, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"
}

body {
  scroll-behavior: smooth !important;
  background-color: #fff;
  color: #2d3844;
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important
}

a {
  text-decoration: none;
  color: inherit
}

// Twillio Chat 

.Twilio.Twilio-MainContainer.css-1m7cg4h {
	width: 360px;
	border-radius: 8px
}

.Twilio-Icon.Twilio-Icon-Read.css-y8bnhq {
	display: none
}

.Twilio-MessageInputArea-TextArea.css-z0ednd {
	border: 1px solid #bac9da
}

.Twilio-MessageCanvasTray-default .Twilio-Button {
	background-color: #fff;
	border-radius: 32px;
	color: #20252a;
	padding: 16px;
	height: 48px
}

.Twilio-MessageCanvasTray-default .MessageCanvasTrayContent h6,
.Twilio-MessageCanvasTray-default .MessageCanvasTrayContent p {
	text-align: center;
	color: #fff
}

@media (max-width:575px) {
	.Twilio.Twilio-MainContainer.css-1m7cg4h {
		top: 0;
		right: 0;
		height: 100%;
		width: 100%;
		border-radius: 0;
		max-height: 100%;
		z-index: 999
	}

	.Twilio-MessageInputArea-TextArea.css-z0ednd textarea {
		font-size: 16px
	}
}

@media screen and (-webkit-min-device-pixel-ratio:0) {

	input,
	select,
	textarea {
		font-size: 16px
	}
}

// Slick
.slick-list,
.slick-slider,
.slick-track {
	position: relative;
	display: block
}

.slick-loading .slick-slide,
.slick-loading .slick-track {
	visibility: hidden
}

.slick-slider {
	box-sizing: border-box;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	-webkit-touch-callout: none;
	-khtml-user-select: none;
	-ms-touch-action: pan-y;
	touch-action: pan-y;
	-webkit-tap-highlight-color: transparent
}

.slick-list {
	overflow: hidden;
	margin: 0;
	padding: 0
}

.slick-list:focus {
	outline: 0
}

.slick-list.dragging {
	cursor: pointer;
	cursor: hand
}

.slick-slider .slick-list,
.slick-slider .slick-track {
	-webkit-transform: translate3d(0, 0, 0);
	-moz-transform: translate3d(0, 0, 0);
	-ms-transform: translate3d(0, 0, 0);
	-o-transform: translate3d(0, 0, 0);
	transform: translate3d(0, 0, 0)
}

.slick-track {
	top: 0;
	left: 0
}

.slick-track:after,
.slick-track:before {
	display: table;
	content: ''
}

.slick-track:after {
	clear: both
}

.slick-slide {
	display: none;
	float: left;
	height: 100%;
	min-height: 1px
}

[dir=rtl] .slick-slide {
	float: right
}

.slick-initialized .slick-slide,
.slick-slide img {
	display: block
}

.slick-arrow.slick-hidden,
.slick-slide.slick-loading img {
	display: none
}

.slick-slide.dragging img {
	pointer-events: none
}

.slick-vertical .slick-slide {
	display: block;
	height: auto;
	border: 1px solid transparent
}
`;

export default GlobalStyle;
